import { TrackingConstant } from 'client/tracking/constant';

export const VEHICLE_DROPDOWNS_TRACKING = {
  styleSelectTrackingId: TrackingConstant.STYLE_SELECT,
  styleSelectTrackingValuePath: 'id',
};
